import { createContext, useContext } from 'react';

export const TableSortContext = createContext(null);

export function useTableSortContext() {
  const v = useContext(TableSortContext);
  if (!v) throw new Error('useTableSortContext outside provider');
  return v;
}
